import { mapState } from 'vuex';
import { getThemeImage, getThemeColor, getThemeGradient, getThemeCopy } from '@/utils/theme';

/**
 * 主题 mixin — 在组件中使用 themeImg('submit') 等
 */
export default {
  computed: {
    ...mapState('theme', ['themeId', 'theme']),
    themeImages() {
      return this.theme?.images || {};
    },
    themeColors() {
      return this.theme?.colors || {};
    },
    themeGradients() {
      return this.theme?.gradients || {};
    },
    /** 优先 API logoFileUrl，其次主题 logo */
    themeLogoUrl() {
      const config =
        this.pageData?.configData ||
        this.repaymentData?.configData ||
        {};
      if (config.logoFileUrl) return config.logoFileUrl;
      return this.themeImg('logo') || '';
    },
    /** 优先 API bannerFileUrl，其次主题 banner / header 渐变 */
    themeBannerStyle() {
      const config =
        this.pageData?.configData ||
        this.repaymentData?.configData ||
        {};
      if (config.bannerFileUrl) {
        return {
          background: `url(${config.bannerFileUrl}) no-repeat`,
          backgroundSize: '100% 100%',
        };
      }
      const banner = this.themeImg('banner');
      if (banner) {
        const isCustomBlue = this.themeId === 'custom-blue';
        return {
          background: `url(${banner}) no-repeat`,
          backgroundPosition: isCustomBlue ? 'bottom center' : undefined,
          backgroundSize: isCustomBlue ? 'cover' : '100% 100%',
        };
      }
      const gradient = this.themeGradient('header');
      if (gradient) {
        return {
          background: gradient,
          backgroundSize: '100% 100%',
        };
      }
      return null;
    },
    paymentMethodSelectedImg() {
      return getThemeImage('paymentSelected') || require('@/assets/CI/true.png');
    },
    checkoutPageTagline() {
      return getThemeCopy('checkoutPage.tagline', this.$i18n.locale);
    },
    checkoutPageTitle() {
      return getThemeCopy('checkoutPage.title', this.$i18n.locale);
    },
    checkoutPageSubtitle() {
      return getThemeCopy('checkoutPage.subtitle', this.$i18n.locale);
    },
    checkoutAmountLabel() {
      return getThemeCopy('checkoutPage.amountLabel', this.$i18n.locale);
    },
    checkoutCountdownLabel() {
      return getThemeCopy('checkoutPage.countdownLabel', this.$i18n.locale);
    },
    checkoutPayeePrefix() {
      return getThemeCopy('checkoutPage.payeePrefix', this.$i18n.locale);
    },
    checkoutAccountHolderLabel() {
      return getThemeCopy('checkoutPage.accountHolderLabel', this.$i18n.locale);
    },
    checkoutCopyLabel() {
      return getThemeCopy('checkoutPage.copyLabel', this.$i18n.locale);
    },
    checkoutSheetIntro() {
      return getThemeCopy('checkoutPage.sheetIntro', this.$i18n.locale);
    },
    checkoutWalletLabel() {
      return getThemeCopy('checkoutPage.walletLabel', this.$i18n.locale);
    },
    checkoutAccountSectionLabel() {
      return getThemeCopy('checkoutPage.accountSectionLabel', this.$i18n.locale);
    },
    checkoutSuccessTitle() {
      return getThemeCopy('successPage.title', this.$i18n.locale);
    },
    checkoutSuccessSubtitle() {
      return getThemeCopy('successPage.subtitle', this.$i18n.locale);
    },
    checkoutSuccessStatusLabel() {
      return getThemeCopy('successPage.statusLabel', this.$i18n.locale);
    },
    checkoutSuccessStatusValue() {
      return getThemeCopy('successPage.statusValue', this.$i18n.locale);
    },
    isCustomBlueTheme() {
      return this.themeId === 'custom-blue';
    },
    isPaymentAccountEntryPageTheme() {
      return ['self-blue', 'custom-gold'].includes(this.themeId);
    },
    themeRootClass() {
      return this.isCustomBlueTheme ? 'pay-theme-layout--custom-blue' : '';
    },
  },
  methods: {
    themeImg(key) {
      return getThemeImage(key);
    },
    themeColor(key) {
      return getThemeColor(key);
    },
    themeGradient(key) {
      return getThemeGradient(key);
    },
  },
};
